// extracted by mini-css-extract-plugin
module.exports = {"cakeTopperInfoWrapper":"CustomCakeTopperInfo_cakeTopperInfoWrapper__215DK","cakeTopperInfoText":"CustomCakeTopperInfo_cakeTopperInfoText__3Egm4"};